import {FeatureToggle, getDefaultBuildingId, getWorkdayByDate} from '../../data';
import {useAppSelector} from '../../hooks';
import {useHomeBuildingId_timeslots} from './timeslots/useHomeBuildingId_timeslots';

export const useHomeBuildingId = (dateKey: string): string => {
  const workday = useAppSelector((state) => getWorkdayByDate(state, dateKey));
  const defaultBuildingId = useAppSelector(getDefaultBuildingId);
  const buildingId = workday?.nodeId ?? defaultBuildingId;

  const timeslotsEnabled = useAppSelector((state) =>
    state.data.features.enabledFeatures.includes(FeatureToggle.TimeslotsApi),
  );
  const timeslotsBuildingId = useHomeBuildingId_timeslots(dateKey);

  return timeslotsEnabled ? timeslotsBuildingId : buildingId;
};
